<script lang="js">
import { mapGetters } from "vuex";

export default {
  name: "Application Form",
  data() {
    return {
      profileImage: "https://avatar.iran.liara.run/public/39",
      numSittings: 1,
      sittings: [{ examType: "", examYear: "", examNumber: "" }],
      examYears: this.getExamYears(),
      subjects: [
        { name: "English", grade: "" },
        { name: "Mathematics", grade: "" }
      ],
      subjectOptions: ["Mathematics", "English", "Biology", "Chemistry", "Physics",
        "Government", "Economics", "Commerce", "Literature", "Geography",
        "Further Mathematics", "Agricultural Science"
      ],
      grades: ["A1", "B2", "B3", "C4", "C5", "C6", "D7", "E8", "F9"]
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getUser"]), // Access user data
    user() {
      return this.getUser;
    },
  },
  methods: {
    getExamYears() {
      const currentYear = new Date().getFullYear();
      const startYear = 1980; // Adjust as needed
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i);
    },
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.profileImage = URL.createObjectURL(file);
        console.log("Selected file:", file.name);
      }
    },
    addSitting() {
      if (this.sittings.length < 2) { // Limit to 2 sittings
        this.sittings.push({ examType: "", examYear: "", examNumber: "" });
      }
    },
    removeSitting(index) {
      this.sittings.splice(index, 1);
    },
    addSubject() {
      if (this.subjects.length < 11) { // Max 11 subjects
        this.subjects.push({ name: "", grade: "" });
      }
    },
    removeSubject(index) {
      this.subjects.splice(index, 1);
    },
    availableSubjects(index) {
      const selectedSubjects = this.subjects.map(subject => subject.name);
      return this.subjectOptions.filter(subject =>
        !selectedSubjects.includes(subject) || subject === this.subjects[index].name
      );
    },
    // availableSittings(index){

    // }
  },
  components: {},
};
</script>

<template>
  <div class="p-4 text-center">
    <RouterLink to="/app">
      <img src="../assets/logo.png" class="" alt="" width="96.26" height="70" />
    </RouterLink>
    <hr />
    <h4 class="fw-bold mt-4">Application Form</h4>

    <p>
      Please fill with accurate information, you can combine at most two
      diiffrent result. Fields with <span class="text-danger">*</span> are
      required.
    </p>
    <form
      action=""
      class="text-start col-md-8 mx-auto"
      @submit.prevent="submitForm"
    >
      <!-- Personal Information -->
      <div class="d-flex justify-content-center mt-5 mb-3">
        <div
          class="title-container d-inline-flex align-items-center position-relative"
        >
          <i class="bi bi-person-circle fs-4 me-2"></i>
          <h6 class="fw-bold mb-0">Personal Information</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 mb-3">
          <div class="image-upload-container" @click="openFilePicker">
            <img
              :src="profileImage"
              class="img-upload"
              alt="Profile Image"
              width="150"
              height="150"
            />
            <div class="hover-overlay">Click to Upload</div>
          </div>
          <input
            type="file"
            ref="fileInput"
            class="d-none"
            @change="handleImageUpload"
            accept="image/*"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label for="exampleInput1" class="form-label"
            >Application Number <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="exampleInput1"
            v-model="user.appnum"
            readonly
            disabled
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Surname <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput2"
              v-model="user.surname"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput3" class="form-label"
              >First Name <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput3"
              v-model="user.firstname"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput4" class="form-label">Other Name </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput4"
              v-model="user.othername"
              readonly
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput5" class="form-label"
              >Gender <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="Default select example">
              <option disabled selected>-- Select --</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Email address <span class="text-danger">*</span></label
            >
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="name@example.com"
              v-model="user.email"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleFormControlInput2" class="form-label"
              >Mobile No <span class="text-danger">*</span></label
            >
            <input
              type="number"
              class="form-control"
              id="exampleFormControlInput2"
              placeholder="08012345678"
              v-model="user.phone"
              readonly
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="dob" class="form-label"
              >Date of Birth <span class="text-danger">*</span>
            </label>
            <input
              type="date"
              class="form-control"
              name="dob"
              id="dob"
              v-model="user.dob"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-8">
          <div class="mb-3">
            <label for="perAddress" class="form-label"
              >Permanent Address <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="perAddress"
              placeholder="123 ABC"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Nationality <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="Country select">
              <option selected disabled>-- Select --</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >State of Origin <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="State select">
              <option selected disabled>-- Select --</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >LGA <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="local gov area select">
              <option selected disabled>-- Select --</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Place of Birth <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="POB select">
              <option selected disabled>-- Select --</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Marital Status <span class="text-danger">*</span>
            </label>
            <select class="form-select" aria-label="Marital status select">
              <option selected disabled>-- Select --</option>
              <option value="1">Single</option>
              <option value="2">Divorce</option>
              <option value="3">Widowed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Parent/Guardian Name <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Parent/Guardian Address <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Parent/Guardian Phone <span class="text-danger">*</span>
            </label>
            <input type="number" class="form-control" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Next of Kin Name <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Relationship with Next of Kin <span class="text-danger">*</span>
            </label>
            <select class="form-select">
              <option selected disabled>-- Select --</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Phone Number(Next of Kin) <span class="text-danger">*</span>
            </label>
            <input type="number" class="form-control" />
          </div>
        </div>
      </div>
      <!-- Programme Information -->
      <div class="d-flex justify-content-center mt-5 mb-3">
        <div
          class="title-container d-inline-flex align-items-center position-relative"
        >
          <i class="bi bi-book fs-4 me-2"></i>
          <h6 class="fw-bold mb-0">Programme Information</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Programme Type
            </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput2"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput3" class="form-label"
              >Academic Session
            </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput3"
              v-model="user.entrysession"
              readonly
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <label for="exampleInput4" class="form-label">School </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput4"
              readonl
              disabled
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="exampleInput4" class="form-label"
              >Programme/Course
            </label>
            <input
              type="text"
              class="form-control"
              id="exampleInput4"
              readonly
              disabled
            />
          </div>
        </div>
      </div>
      <!-- Academic Background -->
      <div class="d-flex justify-content-center mt-5 mb-3">
        <div
          class="title-container d-inline-flex align-items-center position-relative"
        >
          <i class="bi bi-mortarboard-fill fs-4 me-2"></i>
          <h6 class="fw-bold mb-0">Academic Background</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Primary School <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" id="exampleInput2" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="exampleInput3" class="form-label"
              >Start date <span class="text-danger">*</span>
            </label>
            <input type="date" class="form-control" id="exampleInput3" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="exampleInput4" class="form-label"
              >End Date <span class="text-danger">*</span></label
            >
            <input type="date" class="form-control" id="exampleInput4" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="exampleInput2" class="form-label"
              >Secondary School <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control" id="exampleInput2" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="exampleInput3" class="form-label"
              >Start date <span class="text-danger">*</span>
            </label>
            <input type="date" class="form-control" id="exampleInput3" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="exampleInput4" class="form-label"
              >End Date <span class="text-danger">*</span></label
            >
            <input type="date" class="form-control" id="exampleInput4" />
          </div>
        </div>
      </div>
      <!-- Post Secondary School -->
      <div class="d-flex justify-content-center mt-5 mb-3">
        <div
          class="title-container d-inline-flex align-items-center position-relative"
        >
          <i class="bi bi-person-circle fs-4 me-2"></i>
          <h6 class="fw-bold mb-0">
            Post Secondary School
            <span class="fw-normal" style="font-size: small"
              >(e.g. WASSSCE, NECO, GCE, etc)</span
            >
          </h6>
        </div>
      </div>

      <div class="row" v-for="(sitting, index) in sittings" :key="index">
        <h6 class="">Sitting {{ index + 1 }}</h6>

        <div class="col-md-4">
          <label class="form-label"
            >Exam Type <span class="text-danger">*</span></label
          >
          <select class="form-control" v-model="sitting.examType">
            <option value="" disabled>-- Select --</option>
            <option value="SSCE">SSCE</option>
            <option value="NECO">NECO</option>
            <option value="GCE">GCE</option>
            <option value="NABTEB">NABTEB</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label"
            >Exam Year <span class="text-danger">*</span></label
          >
          <select class="form-control" v-model="sitting.examYear">
            <option value="" disabled>-- Select --</option>
            <option v-for="year in examYears" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label"
            >Exam Number <span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="sitting.examNumber"
            placeholder="Enter Exam Number"
          />
        </div>
        <a
          @click="removeSitting(index)"
          v-if="sittings.length > 1"
          class="link-danger link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover mt-2 text-end"
          style="text-decoration-style: dashed"
        >
          Remove
        </a>
      </div>

      <button
        type="button"
        class="btn btn-outline-secondary btn-sm mt-2"
        @click="addSitting"
        :disabled="sittings.length >= 2"
      >
        <i class="bi bi-plus"></i> Add
      </button>

      <!-- Result -->
      <div class="d-flex justify-content-center mt-5 mb-3">
        <div
          class="title-container d-inline-flex align-items-center position-relative"
        >
          <i class="bi bi-postcard fs-4 me-2"></i>
          <h6 class="fw-bold mb-0">O'Level Result</h6>
        </div>
      </div>

      <div v-for="(subject, index) in subjects" :key="index" class="row mb-3">
        <div class="col-md-6">
          <label class="form-label"
            >Subject <span class="text-danger">*</span></label
          >
          <select
            class="form-control"
            v-model="subject.name"
            :disabled="index < 2"
          >
            <option disabled>-- Select --</option>
            <option
              v-for="option in availableSubjects(index)"
              :key="option"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">
            Grade <span class="text-danger">*</span></label
          >
          <select class="form-control" v-model="subject.grade">
            <option value="" disabled>-- Select --</option>
            <option v-for="grade in grades" :key="grade" :value="grade">
              {{ grade }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">
            Sitting <span class="text-danger">*</span></label
          >
          <select class="form-select" aria-label="Default select example">
            <option selected disabled>-- Select --</option>
            <option value="1">Sitting 1</option>
            <option value="2">Sitting 2</option>
          </select>
        </div>
        <div class="col-md-1 d-flex align-items-end">
          <a
            @click="removeSubject(index)"
            v-if="index >= 2"
            class="link-danger link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
            style="text-decoration-style: dashed"
          >
            Remove
          </a>
        </div>
      </div>

      <button
        class="btn btn-outline-secondary btn-sm mt-3"
        @click="addSubject"
        :disabled="subjects.length >= 11"
      >
        <i class="bi bi-plus"></i> Add Subject
      </button>

      <!-- Submit Button -->
      <div class="text-center mt-4">
        <RouterLink to="/app" class="btn btn-success">Submit</RouterLink>
      </div>
    </form>
  </div>
</template>

<style scoped>
.border-custom-secondary {
  border-color: #e9b500 !important;
}

.title-container::after {
  content: "";
  position: absolute;
  bottom: -5px;
  /* Position below the text */
  left: 50%;
  width: 20%;
  /* Border width */
  height: 2px;
  /* Border thickness */
  background-color: #e9b500;
  /* Border color */
  transform: translateX(-50%);
  /* Center the border */
}

.image-upload-container {
  position: relative;
  width: 150px;
  height: 150px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: 2px dashed #ccc;
}

.img-upload {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  padding: 5px;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 8px;
}

.image-upload-container:hover .hover-overlay {
  opacity: 1;
}
</style>
